// extracted by mini-css-extract-plugin
module.exports = {"dots":"Dots_dots__ZFJ1a","dots4":"Dots_dots4__3F6SE"};